import { useContext } from "react";
import { WillEditorContext } from "../will-editor";
import STKButton from "@/components/common/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WillTypes } from "@/types";

type Props = {
    views: JSX.Element[],
    currentView: number,
    setView: (viewIndex:number) =>  void,
    generateWill: () => void,
    generatingWill: boolean,
    willType: WillTypes
}

const PrevButton = ( props: { setView: (viewIndex:number) =>  void, currentView:number} ) => {
    const { css } = useContext(WillEditorContext);
    return (
        <button className={css.navigation__prevButton} onClick={() => {
            props.setView(props.currentView-1); 
        }}><FontAwesomeIcon icon={["fal", "chevron-left"]} />Takaisin</button> 
    );
}

const NextButton = ( props: { setView: (viewIndex:number) =>  void, currentView:number} ) => {
    
    return( 
        <STKButton onClick={() => {
            
            props.setView(props.currentView+1); 
        }}>Seuraava</STKButton> 
    );
}

const GenerateWillButton = ( props: { generateWill: () => void, generatingWill: boolean, willType: WillTypes} ) => {
    // Displayed on last view, whore will is generated
    return(
        <>
        <STKButton onClick={props.generateWill} loading={props.generatingWill}>{props.willType == 'WILL' ? <>Lataa testamentti</> : <>Rekisteröi</> }</STKButton>  
        </>
    );
}

const Navigation = ( props:Props ) => {
    const { css } = useContext(WillEditorContext);
    return(
        <div className={css.navigation__buttons}>
            {props.currentView !== 0 && <PrevButton setView={props.setView} currentView={props.currentView} />}
            {props.currentView === props.views.length-1 ?
                <GenerateWillButton generateWill={props.generateWill} generatingWill={props.generatingWill} willType={props.willType} />
                :
                <NextButton setView={props.setView} currentView={props.currentView} />
            }
        </div>
    ); 

}

export default Navigation;